import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private readonly SKIP_INTERCEPTOR_HEADER = 'skip_interceptor';

  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Check if request should skip interceptor
    if (request.headers.has(this.SKIP_INTERCEPTOR_HEADER)) {
      const modifiedRequest = request.clone({
        headers: request.headers.delete(this.SKIP_INTERCEPTOR_HEADER)
      });
      return next.handle(modifiedRequest);
    }

    const token = localStorage.getItem('jwt_token');
    
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }
} 